import React from 'react';

import { SettingsBackLink } from './SettingsBackLink';
import { SettingsSaveBar } from './SettingsSaveBar';
import { SettingsSaveBarContext } from './SettingsSaveBarContext';

/**
 * Where the save bar shows: the page's top right. Sticky and zero-height so it
 * stays in view while the page scrolls without pushing the column down.
 */
export const SettingsSaveBarSlot = () => {
  const saveBar = React.useContext(SettingsSaveBarContext);
  if (!saveBar) return null;

  return (
    <div className="sticky top-0 z-10 h-0">
      {/* Content scrolling under the buttons fades out instead of showing
          through them, as on the Add App page. It stops at the column's 64px
          top padding, so the page title is never covered. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-16 bg-[linear-gradient(to_bottom,white_48px,transparent)]"
      />
      {/* Phones show the back link above the page title instead. */}
      {saveBar.back && (
        <div className="absolute top-4 left-6 max-sm:hidden">
          <SettingsBackLink {...saveBar.back} className="-ml-1.5" />
        </div>
      )}
      <div className="absolute top-4 right-6">
        <SettingsSaveBar {...saveBar} />
      </div>
    </div>
  );
};
